import React from 'react';
import { Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { Text } = Typography;

const ChartCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  height: 100%;
`;

const RefreshCard = ({ onRefresh }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <ChartCard style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Actualización de Datos</Text>
                <Button
                    type="primary"
                    shape="round"
                    icon={<ReloadOutlined />}
                    onClick={() => onRefresh()}
                    size="large"
                >
                    Recargar Ahora
                </Button>
                <Text type="secondary" style={{ fontSize: 12 }}>Última sincronización: Hace un momento</Text>
            </ChartCard>
        </div>
    );
};

export default RefreshCard;
